import { ReactNode } from 'react';
import { Divider } from '@layout/components/Divider';

type WidgetProps = {
  header: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  footerBg?: string;
};

export const Widget = ({ header, footer, children, footerBg }: WidgetProps) => {
  const footerClasses = `widget-footer ${footerBg || ''}`;
  return (
    <div className="bg-transparent rounded-[3rem] w-full flex flex-col h-full justify-between shadow-pfotenpunkte">
      <div className="widget-header">{header}</div>
      <div className="flex justify-center flex-grow widget-content bg-white">{children}</div>
      {footer && (
        <>
          <div className={footerClasses}>
            <Divider />
            <div className="widget-footer-inner">{footer}</div>
          </div>
        </>
      )}
    </div>
  );
};
